import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Modal, Grid, Paper } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import { Input } from "../../style/Input";
import { Label } from "../../style/Label";
import { Button } from "../../style/Button";
import { Table } from "../../style/Modal";
import { FaEdit } from "react-icons/fa";
import moment from "moment";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { render } from "@testing-library/react";
import PropTypes from "prop-types";
import { withStyles, styled } from "@material-ui/styles";
import { subject } from "../../service";
import "./diag.css";
import MedizenCreative from "../NewCreatives/MedizenCreative/MedizenCreative";
import PrimeraCreative from "../NewCreatives/PrimeraCreative/PrimeraCreative";
import PanazCreative from "../NewCreatives/PanazCreative/PanazCreative";
import { ImCross } from "react-icons/im";
import MedizenVerticalAd from "../../assets/Ads/MedizenV.jpg";
import PrimeraVerticalAd from "../../assets/Ads/PrimeraV.jpg";
import PanazVerticalAd from "../../assets/Ads/PanazV.jpg";
import { Margin } from "devextreme-react/bar-gauge";

const headerMap = {
  1: MedizenVerticalAd,
  2: PrimeraVerticalAd,
  3: PanazVerticalAd,
};

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}
const Item = styled(Paper)(({ theme }) => ({
  textAlign: "center",
}));
const useStyles = (theme) => ({
  paper: {
    position: "absolute",
    width: "400px",
    backgroundColor: "white",
    borderRadius: "10px",
  },
  select: {
    minWidth: "111%",
    fontSize: "12px",
    fontWeight: "400",
    fontFamily: "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
    color: "#58595B",
    border: "1px solid lightgrey",
    padding: "2px 5px 2px 15px",
    borderRadius: "4px",
  },
});

class SimpleModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.sendMessage = this.sendMessage.bind(this);

    this.state = {
      isOpen: false,
    };

    this.procedure = {
      title: "",
      coding: "",
      status: "",
      occurrence: "",
      reffered: "",
      beginDate: "",
      endDate: "",
      imageHeader: "Ads/Horizontal1.jpeg",
      imageBottom: "Ads/Horizontal2.jpeg",
    };

    let valuee = window.sessionStorage.getItem("keyselected");
    let p0 = new Map();
    p0.set("NA", {
      typeProblem: "None",
      title: "",
      coding: "",
      beginDate: "",
      endDate: "",
    });

    let p1 = new Map();
    p1.set("NA", {
      typeProblem: "None",
      title: "",
      coding: "",
      beginDate: "",
      endDate: "",
      imageHeader: "Ads/Horizontal1.jpeg",
      imageBottom: "Ads/Horizontal2.jpeg",
    });
    p1.set("nsclc", {
      typeProblem: "Non Small Cell Lung Cancer (NSCLC)",
      title: "Lung Cancer Stage-II",
      coding: "ICD 10 - C34.90",
      beginDate: moment().format("DD-MMM-YYYY"),
      endDate: "NA",
      imageHeader: "Ads/Horizontal2.jpeg",
      imageBottom: "Ads/Horizontal3.jpeg",
    });

    let p2 = new Map();
    p2.set("NA", {
      typeProblem: "None",
      title: "",
      coding: "",
      beginDate: "",
      endDate: "",
      imageHeader: "Ads/Horizontal1.jpeg",
      imageBottom: "Ads/Horizontal2.jpeg",
    });
    p2.set("c19", {
      typeProblem: "ADPKD Progression",
      title: "ADPKD Progression",
      coding: "Q61.2, Q61.3",
      beginDate: moment().format("DD-MMM-YYYY"),
      endDate: "NA",
      imageHeader: "Ads/Horizontal2.jpeg",
      imageBottom: "Ads/Horizontal3.jpeg",
    });
    p2.set("pcss19", {
      typeProblem: "TYPE || Diabetes",
      title: "TYPE || Diabetes",
      coding: "E11.9",
      beginDate: moment().format("DD-MMM-YYYY"),
      endDate: "NA",
      imageHeader: "Ads/Horizontal3.jpeg",
      imageBottom: "Ads/Horizontal4.jpeg",
    });
    p2.set("myelo", {
      typeProblem: "Myelofibrosis",
      title: "Myelofibrosis",
      coding: "D75.81",
      beginDate: moment().format("DD-MMM-YYYY"),
      endDate: "NA",
      imageHeader: "Ads/Horizontal3.jpeg",
      imageBottom: "Ads/Horizontal4.jpeg",
    });

    let p3 = new Map();
    p3.set("NA", {
      typeProblem: "None",
      title: "",
      coding: "",
      beginDate: "",
      endDate: "",
      imageHeader: "Ads/Horizontal1.jpeg",
      imageBottom: "Ads/Horizontal2.jpeg",
    });
    p3.set("T2DM", {
      typeProblem: "T2DM with Diabetic Neuropathy - ICD 10 Code - E11.40",
      title: "Diabetic Neuropathy of legs",
      coding: "E11.�40",
      beginDate: moment().format("DD-MMM-YYYY"),
      endDate: "NA",
      imageHeader: "Ads/Horizontal4.jpeg",
      imageBottom: "Ads/Horizontal5.jpeg",
    });

    p3.set("ADPKD", {
      typeProblem: "APKD Progression",
      title: "ADPKD Progression",
      coding: "ICD10: Q61.2,Q61.3",
      beginDate: moment().format("DD-MMM-YYYY"),
      endDate: "NA",
      imageHeader: "Ads/Horizontal4.jpeg",
      imageBottom: "Ads/Horizontal5.jpeg",
    });

    let cMap = new Map();
    cMap.set(0, p0);
    cMap.set(1, p2);
    cMap.set(2, p2);
    cMap.set(3, p2);
    cMap.set(4, p2);
    cMap.set(5, p2);

    if (!valuee) valuee = 0;

    this.datasets = cMap.get(parseInt("1"));
  }

  handleChange = (event) => {
    let dataset = this.datasets.get(event.target.value);

    if (dataset) {
      this.procedure.title = dataset.title;
      this.procedure.coding = dataset.coding;
      this.procedure.status = "Active";
      this.procedure.occurrence = "NA";
      this.procedure.reffered = "Reffered By";
      this.procedure.beginDate = dataset.beginDate;
      this.procedure.endDate = dataset.endDate;
      this.procedure.imageHeader = dataset.imageHeader;
      this.procedure.imageBottom = dataset.imageBottom;
    }

    this.forceUpdate();
  };

  handleOpen = () => {
    this.setState({ isOpen: true });
    this.procedure.title = "";
    this.procedure.coding = "";
    this.procedure.status = "";
    this.procedure.occurrence = "";
    this.procedure.reffered = "";
    this.procedure.beginDate = "";
    this.procedure.endDate = "";
    this.procedure.imageHeader = "Ads/Horizontal1.jpeg";
    this.procedure.imageBottom = "Ads/Horizontal2.jpeg";
  };

  handleClose = () => this.setState({ isOpen: false });

  sendMessage = () => {
    let imagesel = {
      headerImg: this.procedure.imageHeader,
      leftImg: "",
      bottomImg: "",
    };

    subject.next(JSON.stringify(imagesel));
  };

  handleSave = () => {
    if (this.procedure.title) {
      this.setState({ isOpen: false });
      this.sendMessage();
      this.props.onSubmitChild(this.procedure);
    }
    if (this.procedure.title === "ADPKD Progression") {
      const headerMapKey = 1;
      this.props.setSelectedBanner(headerMap[headerMapKey]);
      window.sessionStorage.setItem("rValue", headerMapKey);
    } else if (this.procedure.title === "TYPE || Diabetes") {
      const headerMapKey = 2;
      this.props.setSelectedBanner(headerMap[headerMapKey]);
      window.sessionStorage.setItem("rValue", headerMapKey);
    } else if (this.procedure.title === "Myelofibrosis") {
      const headerMapKey = 3;
      this.props.setSelectedBanner(headerMap[headerMapKey]);
      window.sessionStorage.setItem("rValue", headerMapKey);
    }
  };

  render() {
    const { classes } = this.props;
    const mystyle = {
      top: "30%",
      margin: "0 auto",
      width: "514px",
      padding: "0px",
      left: "0",
      right: "0"
    };
    return (
      <div>
        <div style={{ marginLeft: "15px" }}>
          <Button
            className="button3"
            borderRadius="20px"
            padding="2px 17px"
            height="fit-content"
            style={{
              marginTop: "4px",
              fontSize: "18px",
              fontFamily:
                "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
              fontWeight: 600,
              backgroundImage:
                "linear-gradient(315deg, #7f7f7f 0%, #9e9e9e 74%)",
              color: "white",
            }}
            onClick={this.handleOpen}
          >
            + Add
          </Button>
        </div>

        <Modal
          open={this.state.isOpen}
          onClose={this.handleClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ outline: "none !important" }}
        >
          <div className="">
            <div style={mystyle} className={`${classes.paper} responsiveModal`}>
              <h4
                style={{
                  color: "#4678ED",
                  fontFamily:
                    "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                  fontSize: "19.px",
                  fontWeight: 666,
                  padding: "25px 15px 0px 15px",
                }}
              >
                Add/Edit Issue{" "}
                <span style={{ float: "right", color: "black" }}></span>
              </h4>
              <hr style={{ padding: "0px" }} />
              <div style={{ padding: "21px 10px 20px 35px" }}>
                <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                  <Grid
                    item
                    md={4} xs={4}
                    style={{
                      fontWeight: "400",
                      fontFamily:
                        "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                      color: "#58595B",
                      fontSize: "15.52px",
                      textAlign: "right",
                      marginTop: "5px",
                    }}
                  >
                    Type : Problem
                  </Grid>
                  <Grid item md={6} xs={6}>
                    <Select
                      className={classes.select}
                      defaultValue={"NA"}
                      name="complaint"
                      onChange={this.handleChange}
                      style={{ minWidth: "100%" }}
                    >
                      {[...this.datasets.keys()].map((keey, index) => (
                        <MenuItem value={keey}>
                          {this.datasets.get(keey).typeProblem}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>

                </Grid>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={4} xs={4}
                    style={{
                      fontWeight: "400",
                      fontFamily:
                        "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                      color: "#58595B",
                      fontSize: "15.52px",
                      textAlign: "right",
                      marginTop: "5px",
                    }}
                  >
                    Title:
                  </Grid>
                  <Grid item md={6} xs={6}>
                    <Input
                      style={{
                        borderRadius: "5px",
                        border: "1px solid lightgrey",
                        minWidth: "100%"
                      }}
                      display="inline"
                      value={this.procedure.title || ""}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={4} xs={4}
                    style={{
                      fontWeight: "400",
                      fontFamily:
                        "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                      color: "#58595B",
                      fontSize: "15.52px",
                      textAlign: "right",
                      marginTop: "5px",
                    }}
                  >
                    Coding:
                  </Grid>
                  <Grid item md={6} xs={6}>
                    <Input
                      height="60px"
                      style={{
                        borderRadius: "5px",
                        border: "1px solid lightgrey",
                        minWidth: "100%"
                      }}
                      display="inline"
                      value={this.procedure.coding || ""}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item md={4} xs={4}></Grid>
                  <Grid item md={8} xs={8}>
                    <Grid container spacing={2}>
                      <Grid item xs={5}>
                        <Button
                          style={{
                            padding: "3px 18px",
                            height: "fit-content",
                            borderRadius: "3px",
                            border: "1px solid lightgrey",
                            fontSize: "13px",
                            marginBottom: "0px",
                            fontWeight: "400",
                            fontFamily:
                              "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                            color: "#58595B",
                            backgroundImage:
                              "linear-gradient(315deg, #ffffff 0%, #ffffff 74%)",
                          }}
                        >
                          Add
                        </Button>{" "}

                      </Grid>
                      <Grid item xs={5}>
                        <Button
                          style={{
                            padding: "3px 18px",
                            height: "fit-content",
                            borderRadius: "3px",
                            border: "1px solid lightgrey",
                            fontSize: "13px",
                            marginBottom: "0px",
                            fontWeight: "400",
                            fontFamily:
                              "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                            color: "#58595B",
                            backgroundImage:
                              "linear-gradient(315deg, #ffffff 0%, #ffffff 74%)",
                            color: "gray",
                          }}
                        >
                          Remove
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={4} xs={4}
                    style={{
                      fontWeight: "400",
                      fontFamily:
                        "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                      color: "#58595B",
                      fontSize: "15.52px",
                      textAlign: "right",
                      marginTop: "5px",
                    }}
                  >
                    Begin Date:
                  </Grid>
                  <Grid item md={6} xs={6}>
                    <Input
                      style={{
                        borderRadius: "5px",
                        border: "1px solid lightgrey",
                        minWidth: "100%"
                      }}
                      display="inline"
                      value={this.procedure.beginDate || ""}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={4} xs={4}
                    style={{
                      fontWeight: "400",
                      fontFamily:
                        "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
                      color: "#58595B",
                      fontSize: "15.52px",
                      textAlign: "right",
                      marginTop: "5px",
                    }}
                  >
                    End Date:
                  </Grid>
                  <Grid item md={6} xs={6}>
                    <Input
                      style={{
                        borderRadius: "5px",
                        border: "1px solid lightgrey",
                        minWidth: "100%"
                      }}
                      display="inline"
                      value={this.procedure.endDate || ""}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item md={4} xs={4}></Grid>
                  <Grid item md={6} xs={6}>
                    <Button
                      style={{
                        float: "right",
                        padding: "3px 18px",
                        marginRight: "-30px",
                        height: "fit-content",
                        borderRadius: "20px",
                        fontSize: "20px",
                        marginBottom: "10px",
                        backgroundImage:
                          "linear-gradient(315deg, #7f7f7f 0%, #9e9e9e 74%)",
                        color: "white",
                        fontFamily: "'Work Sans', sans-serif",
                        fontWeight: 600,
                      }}
                      onClick={this.handleSave}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </Modal >
      </div >
    );
  }
}
SimpleModal.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(useStyles)(SimpleModal);
